import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { RichTextView } from "@/components/forms/RichTextEditor";

const useAbout = () =>
  useQuery({ queryKey: ["about"], queryFn: async () => (await api.get("/about")).data });

export default function About() {
  const { data: c, isLoading } = useAbout();
  useEffect(() => {
    if (c?.heading) document.title = `${c.heading} — Startup Otter`;
  }, [c]);

  if (isLoading || !c) return <div className="min-h-[60vh]" data-testid="about-loading" />;

  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8" data-testid="about-page">
      <h1 className="text-4xl font-[680] tracking-[-0.02em] text-foreground" data-testid="about-heading">{c.heading}</h1>
      <RichTextView
        html={c.body_html}
        className="prose-so-spacious mt-6 text-base leading-7 text-muted-foreground sm:text-lg"
      />
    </div>
  );
}
